import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import cn from 'classnames';
import dataQa from '@platform-ui/dataQa';
import styles from './TooltipBubble.module.css';
export const props = {
  theme: ['dark', 'light', 'blue', 'default', 'elevation-1'],
  align: ['left', 'center', 'right', 'inherit', 'justify']
};
const TooltipBubble = ({
  alignText,
  children,
  cornerStyle,
  direction,
  inline: _inline = false,
  withCorner: _withCorner = true,
  theme: _theme = 'light',
  id,
  overflow: _overflow = 'hidden',
  variant: _variant = 'desktop',
  maxWidth: _maxWidth = 288,
  dataQaType,
  dataQaData,
  setCornerRect,
  setBorderRadius,
  borderRadiusStyle
}) => {
  const cornerRef = useCallback(node => {
    if (node !== null) {
      setCornerRect && setCornerRect(node.getBoundingClientRect());
    }
  }, [setCornerRect]);
  const bubbleRef = useCallback(node => {
    if (node !== null) {
      var _getComputedStyle;
      setBorderRadius && setBorderRadius(parseFloat((_getComputedStyle = getComputedStyle(node)) == null ? void 0 : _getComputedStyle.getPropertyValue('border-radius')) || 12);
    }
  }, [setBorderRadius]);
  const themeType = typeof _theme !== 'object' ? _theme : 'custom';
  const customTheme = _theme;
  const colorCustomStyles = {};
  const backgroundCustomStyles = {};
  const cornerColorCustomStyles = {};
  if (themeType === 'custom') {
    var _customTheme$color, _customTheme$backgrou, _customTheme$cornerCo;
    colorCustomStyles.color = (_customTheme$color = customTheme == null ? void 0 : customTheme.color) != null ? _customTheme$color : 'var(--tui-text-primary)';
    backgroundCustomStyles.background = (_customTheme$backgrou = customTheme == null ? void 0 : customTheme.background) != null ? _customTheme$backgrou : 'var(--tui-background-elevation-1)';
    cornerColorCustomStyles.background = (_customTheme$cornerCo = customTheme == null ? void 0 : customTheme.cornerColor) != null ? _customTheme$cornerCo : 'var(--tui-background-elevation-1)';
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({}, dataQa({
    dataQaData,
    dataQaType: `${dataQaType}.wrapper`
  }), {
    className: styles.bubbleWrapper,
    id: id
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bubble, {
      [styles.bubble_inline]: _inline,
      [styles[`bubble_direction_${direction}`]]: direction,
      [styles[`bubble_theme_${themeType}`]]: true,
      [styles[`bubble_variant_${_variant}`]]: true
    }),
    ref: bubbleRef,
    style: _extends({
      overflow: _overflow,
      maxWidth: _maxWidth
    }, colorCustomStyles, backgroundCustomStyles, borderRadiusStyle),
    "data-qa-type": `${dataQaType}.inner`
  }, _withCorner && /*#__PURE__*/React.createElement("div", {
    ref: cornerRef,
    className: styles.corner,
    style: _extends({}, cornerColorCustomStyles, cornerStyle),
    "data-qa-type": `${dataQaType}.corner`
  }), /*#__PURE__*/React.createElement("div", {
    "data-qa-type": `${dataQaType}.content`,
    className: styles.bubbleContent,
    style: _extends({
      textAlign: alignText
    }, backgroundCustomStyles, borderRadiusStyle)
  }, children)));
};
export default TooltipBubble;